<template>
  <div class="deliverable-listing calendar-view">
    <FullCalendar ref="csm__calendar" :options="{...calendarOptions }">
      <template v-slot:eventContent='arg'>
        <div :id="'eventNo' + arg.event.id">
          <span v-html="arg.event.extendedProps.deliverable + ' > ' + arg.event.title" v-if="(typeof arg.event.extendedProps.deliverable != 'undefined')" @click="handleEventTitleClick(arg)"></span>
          <span v-else v-html="arg.event.title" @click="handleEventTitleClick(arg)"></span>
        </div>
        <b-tooltip custom-class="calendar-due-date-tooltip" :delay="0" :ref="`eventTooltip${arg.event.id}`" triggers="manual" :target="'eventNo' + arg.event.id" :show="calendarDueDateTooltip[`eventTooltip${arg.event.id}`]">
          Due date: {{ formatDueDateTooltip(arg.event.extendedProps.dueDate) }}
        </b-tooltip>
      </template>
      <template v-slot:dayCellContent='arg'>
        <a id="fc-dom-4" class="fc-daygrid-day-number" :aria-label="$moment(arg.date).format('MMMM DD, YYYY')">{{arg.dayNumberText}}</a>
      </template>
    </FullCalendar>
  </div>
</template>
<script>
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list'
import FullCalendar from '@fullcalendar/vue'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
	props:[
    "namespace", 
    "initialView",
    "initialDate",
  ],
  components: {
    FullCalendar, // make the <FullCalendar> tag available
  },
  computed: {
  	...mapState({
  	  state (state) {
  	    return state[this.namespace]
  	  },
  	  deliverableDetail (state, getters) {
  	    return getters[this.namespace + 'deliverableDetail']
  	  },
  	  calendarEvents (state, getters) {
  	    return getters[this.namespace + 'calendarEvents']
  	  },
  	  projectDetail (state, getters) {
  	    return getters[this.namespace + 'projectDetail']
  	  },
  	  taskHighlighted (state, getters) {
  	    return getters[this.namespace + 'taskHighlighted']
  	  },
      calendarFilter(state, getters) {
        return getters[this.namespace + 'calendarFilter']
      },
      getDeliverableTemplateSlug(state, getters) {
        return getters['getDeliverableTemplateSlug']
      },
  	}),
  },
  data() {
    return {
      calendarOptions: {
        events: this.getCalendarEvents,
        plugins: [
          dayGridPlugin,
          listPlugin,
          interactionPlugin // needed for dateClick
        ],
        customButtons: {
          collapseButton: {
            text: 'Collapse',
            click: () => {
              this.handleHideClick(this.$refs.csm__calendar.getApi());
            }
          }
        },
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'collapseButton dayGridDay,dayGridWeek,weekAgenda,dayGridMonth'
        },
        views: {
          weekAgenda: {
            type: 'listWeek',
            buttonText: 'Agenda'
          },
          week: {
            // options apply to dayGridWeek and timeGridWeek views
            dayMaxEvents: false, // Show all events 
          },
          day: {
            // options apply to dayGridDay and timeGridDay views
            dayMaxEvents: false, // Show all events 
          }
        },
        initialView: this.initialView,
        initialDate: this.initialDate,
        height: '100%',
        eventDisplay:'block',
        editable: false,
        selectable: false,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        select: this.handleDateSelect,
        eventClick: this.handleEventTitleClick,
        dateClick: this.handleDateClick,
        datesSet: this.handleDateOrViewChange,
        eventMouseEnter: this.handleEventMouseEnter,
        eventMouseLeave: this.handleEventMouseLeave,
        eventClassNames: 'mb-2',
        moreLinkClick: this.handleMoreLinkClick,
        /* you can update a remote database when these fire:
        eventAdd:
        eventChange:
        eventRemove:
        */
      },
      renderCount: 0,
      expandedEvents: [],
      expandDate: null,

      calendarDueDateTooltip: {},
      calendarDueDateTooltipStay: false,
    }
  },
  mounted() {
    $(".fc-collapseButton-button").attr("disabled", true);

    this.$root.$on('bv::modal::shown', (bvEvent, modalId) => {
      if (modalId == 'editDeliverableModal') {
        if (this.taskHighlighted) {
            let editModal = $("#editDeliverableModal");

            this.$nextTick(() => {
              setTimeout(() => {
                let curEl = $(".task-fields .field-block.highlight");
                const elOffset = curEl.offset();
                editModal.scrollTop(elOffset.top - 0.4 * window.innerHeight);
              }, 100);
            });
        }
      }
    });
    this.$root.$on('calendarHeaderFilterUpdated', this.onCalendarHeaderFilterUpdated);
    this.$root.$on('re__fetch__calendar__data', this.onSingleEventUpdated);
  },
  methods: {
  	...mapActions({
  	  getCalendarData (dispatch, payload) {
  	    return dispatch(this.namespace + 'getCalendarData', payload)
  	  },
  	  getDeliverableCalendarData (dispatch, payload) {
  	    return dispatch(this.namespace + 'getDeliverableCalendarData', payload)
  	  },
  	  fetchProjectDeliverableById (dispatch, payload) {
  	    return dispatch(this.namespace + 'fetchProjectDeliverableById', payload)
  	  },
  	}),
  	...mapMutations({
  	  setDataLoading (commit, payload) {
  	    return commit(this.namespace + 'setDataLoading', payload)
  	  },
  	  setDeliverableFilter (commit, payload) {
  	    return commit(this.namespace + 'setDeliverableFilter', payload)
  	  },
  	}),
    handleDateOrViewChange(dateInfo ){
      const clonedFilterQuery = _.cloneDeep(this.calendarFilter);
      clonedFilterQuery.calendarViewType = dateInfo.view.type;
      this.$store.commit(this.namespace + "setDeliverableFilter", clonedFilterQuery);
    },
    async getCalendarEvents(info, successCallback, failureCallback) {
      if (this.calendarFilter) {
        const clonedFilterQuery = _.cloneDeep(this.calendarFilter);
        clonedFilterQuery.listByDate = true;
        clonedFilterQuery.isCalendarUpdate = true;
        clonedFilterQuery.listByDateRange = {
          startDate: info.start,
          endDate: info.end,
        };
        if (clonedFilterQuery.dataSetType == "") {
          clonedFilterQuery.dataSetType = "deliverables";
        }
        const hasChanged = !_.isEqual(this.calendarFilter, clonedFilterQuery);
        if (hasChanged) {
          // Commit only if there is a change
          this.$store.commit(this.namespace + "setDeliverableFilter", clonedFilterQuery);
        }
        let eventsToShow = [];
        this.setDataLoading(true);
        eventsToShow = await this.$store.dispatch(this.namespace + "getCalendarData").then((resp) => {
          this.setDataLoading(false);
          return resp;
        });
        successCallback(eventsToShow);
      }
    },

    createEventId() {
      let eventGuid = 0
      return String(eventGuid++)
    },

    handleDateSelect(selectInfo) {
      let title = prompt('Please enter a new title for your event')
      let calendarApi = selectInfo.view.calendar

      calendarApi.unselect() // clear date selection

      if (title) {
        calendarApi.addEvent({
          id: this.createEventId(),
          title,
          start: selectInfo.startStr,
          end: selectInfo.endStr,
          allDay: selectInfo.allDay
        })
      }
    },

    handleDateClick(dateClickInfo) {
      this.calendarDueDateTooltipStay = false;
      this.calendarDueDateTooltip = {};
      this.clickedOutsideFilter();
      let existingEvents = dateClickInfo.view.calendar.getEvents();
      existingEvents.forEach(x => {
        x.setProp("classNames", []);
      });
    },

    handleEventClick(clickInfo) {
      this.calendarDueDateTooltipStay = true;
      this.calendarDueDateTooltip = {};
      this.calendarDueDateTooltip[`eventTooltip${clickInfo.event.id}`] = true;
      let existingEvents = clickInfo.view.calendar.getEvents();
      existingEvents.forEach(x => {
        x.setProp("classNames", []);
      });
      clickInfo.event.setProp("classNames", ['selected']);
    },

    handleEventTitleClick(clickInfo) {
      this.clickedOutsideFilter();
      if(typeof clickInfo.event.extendedProps.project != 'undefined') {
        let projectId = clickInfo.event.extendedProps.project_number
        this.goToProject(projectId);
      } else {
        let deliverableId = clickInfo.event.extendedProps.deliverableId || clickInfo.event.id;
        const currentRoute = this.$route;
        let modalHint = null;
        if (clickInfo.event.extendedProps.deliverable_template_id) {
          const template_slug = this.getDeliverableTemplateSlug(
            parseInt(clickInfo.event.extendedProps.deliverable_template_id)
          );
          if (template_slug === "social-media") {
            modalHint = 'social';
          } else if (template_slug === "organic-social-media-plan") {
            modalHint = 'osmp';
          }
        }
        const routeConfig = {
          name: 'calendarDeliverableDetail',
          params: { deliverableId: deliverableId },
          query: { ...currentRoute.query }
        };
        if (modalHint) {
          routeConfig.query.modal = modalHint;
            }
        if (currentRoute.params.deliverableId) {
          this.$router.replace(routeConfig);
        } else {
          this.$router.push(routeConfig);
            }
      }
    },

    handleEventMouseEnter(mouseInfo) {
      if (!this.calendarDueDateTooltipStay) this.calendarDueDateTooltip[`eventTooltip${mouseInfo.event.id}`] = true;
      const classArray = Object.assign([], mouseInfo.event.classNames || []);
      classArray.push('hover');
      mouseInfo.event.setProp("classNames", classArray);
    },
    handleEventMouseLeave(mouseInfo) {
      if (!this.calendarDueDateTooltipStay) this.calendarDueDateTooltip[`eventTooltip${mouseInfo.event.id}`] = false;
      const classArray = Object.assign([], mouseInfo.event.classNames || []);
      const newClassArray = classArray.filter(x => x != 'hover');
      mouseInfo.event.setProp("classNames", newClassArray);
    },

    goToProject(projectId) {
      this.$store.commit(this.namespace + "setDeliverableFilter", this.calendarFilter);
      this.setDataLoading(true);
			this.fetchProjectDeliverableById(projectId).then(() => {
				this.setDataLoading(false);
				this.$router.push('/project/' + projectId);
			});
    },

    handleMoreLinkClick(clickInfo) {
      this.expandDate = clickInfo.date;
      this.calendarOptions.dayMaxEvents = clickInfo.allSegs.length;
      $(".fc-collapseButton-button").attr("disabled", false);
      return clickInfo.view.type;
    },

    handleHideClick(info) {
      this.calendarOptions.dayMaxEvents = true;
      this.expandDate = null;
      $(".fc-collapseButton-button").attr("disabled", true);
    },

    formatDueDateTooltip(date) {
      if (date) {
        const dateMoment = this.$moment(date);
        return dateMoment.format("MMMM DD, YYYY");
      } else {
        return 'No due date';
      }
    },
    onCalendarHeaderFilterUpdated() {
      if (typeof this.$refs.csm__calendar != "undefined") {
        const calendarApi = this.$refs.csm__calendar.getApi();
        // Force FullCalendar to re-render
        calendarApi.refetchEvents();
      }
    },
    async onSingleEventUpdated(eventData) {
      if (typeof this.$refs.csm__calendar != "undefined" && eventData) {
        const calendarApi = this.$refs.csm__calendar.getApi();
        if (eventData.id) {
          let eventInfo = {};
          this.setDataLoading(true);
          let template_slug = this.getDeliverableTemplateSlug(parseInt(eventData.deliverable_template_id));
          if (template_slug == "social-media" && eventData.in_social_series) {
            // refetch entire calendar when closing multi day sm post
            calendarApi.refetchEvents();
          } else {
            eventInfo = await this.getDeliverableCalendarData(eventData.id).then((resp) => {
              this.setDataLoading(false);
              return resp;
            });
            if (Object.entries(eventInfo).length) {
              const eventToUpdate = calendarApi.getEventById(eventData.id);
              if (eventToUpdate) {
                // Force updated event to re-render with latest details
                eventToUpdate.setProp("title", eventInfo.title);
                eventToUpdate.setProp("backgroundColor", eventInfo.backgroundColor);
                eventToUpdate.setExtendedProp("dueDate", eventInfo.extendedProps.dueDate);
                eventToUpdate.setDates(eventInfo.start, eventInfo.end);
              } else {
                // newly created social media post from osmp modal
                calendarApi.addEvent(eventInfo);
              }
            }
          }
        }
      }
    },
  }
}
</script>